export const HISTORY_DEFAULT_TABLE_LIMIT = 10;
